import { createAction } from 'redux-actions';
import { deleteMosObject as apiDeleteMosObject } from '../api/camio';
import {
  getVideoDuration as apiGetVideoDuration,
  openVideo as apiOpenVideo,
  pauseVideo as apiPauseVideo,
  playVideo as apiPlayVideo,
  setPosition as apiSetVideoPosition
} from '../api/clipperStream';

export const VIDEO_SELECTED = 'VIDEO/SELECTED';
export const VIDEO_LOADED = 'VIDEO/LOADED';
export const VIDEO_RESUMED = 'VIDEO/RESUMED';
export const VIDEO_PAUSED = 'VIDEO/PAUSED';
export const VIDEO_JUMPED_TO_START = 'VIDEO/JUMPED_TO_START';
export const VIDEO_JUMPED_TO_END = 'VIDEO/JUMPED_TO_END';
export const VIDEO_SCRUB_STARTED = 'VIDEO/SCRUB_STARTED';
export const VIDEO_SCRUB_ENDED = 'VIDEO/SCRUB_ENDED';
export const VIDEO_SCRUBBED = 'VIDEO/SCRUBBED';
export const VIDEO_UPDATED = 'VIDEO/UPDATED';
export const TIMELINE_SELECT_GRAPHIC = 'TIMELINE/SELECT_GRAPHIC';
export const TIMELINE_REMOVE_GRAPHIC = 'TIMELINE/REMOVE_GRAPHIC';
export const TIMELINE_UPDATE_GRAPHIC_POSITION = 'TIMELINE/UPDATE_GRAPHIC_POSITION';
export const TIMELINE_GRAPHIC_LOSE_FOCUS = 'TIMELINE/GRAPHIC_LOSE_FOCUS';

const videoSelected = (fileUrl, frameRate) =>
  createAction(VIDEO_SELECTED)({ fileUrl, frameRate });

const videoLoaded = (response) => createAction(VIDEO_LOADED)(response);

const loadVideo = (fileUrl, filePath, frameRate) => (dispatch) => {
  dispatch(videoSelected(fileUrl, frameRate));

  apiOpenVideo(filePath)
    .then(response => {
      if (response.result === 'success') {
        return apiGetVideoDuration()
          .then(response2 =>
            dispatch(videoLoaded([response2.instances.top_left.playhead.position[1]])));
      }
      throw Error;
    })
    .catch(error => console.log(`Failed to load video. Error: ${error}`));
};

const videoResumed = () => createAction(VIDEO_RESUMED)();

const playVideo = () => (dispatch) => {
  dispatch(videoResumed());

  apiPlayVideo()
    .catch(error => console.log(`Failed to play video. Error: ${error}`));
};

const videoPaused = () => createAction(VIDEO_PAUSED)();

const pauseVideo = () => (dispatch) => {
  dispatch(videoPaused());

  apiPauseVideo()
    .catch(error => console.log(`Failed to pause video. Error: ${error}`));
};

const videoJumpedToStart = () => createAction(VIDEO_JUMPED_TO_START)();

const jumpVideoToStart = () => (dispatch) => {
  dispatch(videoJumpedToStart());

  apiPauseVideo()
    .then(() => apiSetVideoPosition(0))
    .catch(error => console.log(`Failed to jump video to start. Error: ${error}`));
};

const videoJumpedToEnd = () => createAction(VIDEO_JUMPED_TO_END)();

const jumpVideoToEnd = () => (dispatch) => {
  dispatch(videoJumpedToEnd());

  return apiPauseVideo()
    .then(() => apiSetVideoPosition(1000))
    .catch(error => console.log(`Failed to jump video to end. Error: ${error}`));
};

const videoScrubStarted = () => createAction(VIDEO_SCRUB_STARTED)();

const videoScrubEnded = () => createAction(VIDEO_SCRUB_ENDED)();

const videoScrubbed = (position) => createAction(VIDEO_SCRUBBED)({ position });

const scrubVideo = (position, isPlaying) => (dispatch) => {
  dispatch(videoScrubbed(position));

  if (isPlaying) {
    apiPauseVideo()
      .then(() => apiSetVideoPosition(position))
      .catch(error => console.log(`Failed to scrub video. Position: ${position}. Error: ${error}`));
  } else {
    apiSetVideoPosition(position)
      .catch(error => console.log(`Failed to scrub video. Position: ${position}. Error: ${error}`));
  }
};

const updateVideoFrame = (frame) => createAction(VIDEO_UPDATED)({ frame });

const graphicSelected = (graphicId) => createAction(TIMELINE_SELECT_GRAPHIC)({ graphicId });

const selectGraphic = (graphicId) => (dispatch) => {
  dispatch(graphicSelected(graphicId));

  apiPauseVideo()
    .catch(error => console.log(`Failed to pause video on select graphic. Error: ${error}`));
};

const removeSelectedGraphic = (mosObjectObjectId) => (dispatch) => {
  dispatch(createAction(TIMELINE_REMOVE_GRAPHIC)(mosObjectObjectId));

  apiDeleteMosObject({ mosObjectObjectId })
    .catch(error => console.log(error));
};

const updateGraphicPosition = (graphicId, start, end, isStartHandle) => (dispatch) => {
  const position = isStartHandle ? start : end;
  dispatch(createAction(TIMELINE_UPDATE_GRAPHIC_POSITION)({ graphicId, start, end, position }));

  apiSetVideoPosition(position)
    .catch(error => console.log(`Failed to scrub video on update graphic position. Position: ${position}. Error: ${error}`));
};

const loseGraphicFocus = () => createAction(TIMELINE_GRAPHIC_LOSE_FOCUS)();

export const actions = {
  jumpVideoToEnd,
  jumpVideoToStart,
  loadVideo,
  loseGraphicFocus,
  pauseVideo,
  playVideo,
  removeSelectedGraphic,
  scrubVideo,
  selectGraphic,
  updateGraphicPosition,
  updateVideoFrame,
  videoScrubEnded,
  videoScrubStarted
};



// WEBPACK FOOTER //
// ./app/actions/clipperMovie.js